export { default as OrderList } from './OrderList';
export { default as OrderDisplay } from './OrderDisplay';



// WEBPACK FOOTER //
// ./src/modules/Order/pages/index.ts